import {Command} from '@application/command/command';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionScheduleItemInPathGroup} from '@domain/production-schedule/production-schedule-item-in-path-group';
import {ProductionSchedulePath} from '@domain/production-schedule/production-schedule-path';
import {ParametersForRemovingProductionScheduleItems} from './parameters-for-removing-production-schedule-items';
import {RemoveProductionScheduleItemCommand} from './remove-production-schedule-item-command';

export class RemoveProductionScheduleItemsCommand implements Command<ParametersForRemovingProductionScheduleItems, ProductionSchedule> {
  private readonly removeProductionScheduleItemCommand: RemoveProductionScheduleItemCommand;

  public constructor() {
    this.removeProductionScheduleItemCommand = new RemoveProductionScheduleItemCommand();
  }

  public execute(commandArgs: ParametersForRemovingProductionScheduleItems): ProductionSchedule {
    let {productionSchedule} = commandArgs;
    const {productionScheduleItems} = commandArgs;

    productionScheduleItems.forEach((productionScheduleItem: ProductionScheduleItemInPathGroup) => {
      const productionSchedulePathOfColoredYarnSet = productionSchedule.getProductionSchedulePathsOfColoredYarnSetForProductionScheduleItem(productionScheduleItem);
      const productionSchedulePath: ProductionSchedulePath = productionSchedulePathOfColoredYarnSet.getProductionSchedulePathForProductionScheduleItem(productionScheduleItem);

      productionSchedule = this.removeProductionScheduleItemCommand.execute({
        productionSchedule,
        productionSchedulePathNumber: productionSchedulePath.pathNumber,
        productionScheduleItemInPathGroupUuid: productionScheduleItem.uuid,
        startDentOfColoredYarnSet: productionSchedulePathOfColoredYarnSet.productionScheduleColoredYarnSet.startDent
      });
    });

    return productionSchedule;
  }
}
